export default "<app-panel [editable]=\"editable\" (diffCharacteristicsEvent)=\"onCharacteristicsChange($event)\"></app-panel>"